// extracted by mini-css-extract-plugin
export default {"wrap":"chat_wrap__PlTuk","position":"chat_position__s24Hf","messages":"chat_messages__BqRuU"};